<template v-slot:activator="{ on }">
  <div class="text-center">
    <v-menu
      v-model="menu"
      :close-on-content-click="false"
      fullscreen
      bottom
      offset-y
      style="z-index: 999"
    >
      <template v-slot:activator="{ on: menu }">
        <v-app-bar app clipped-right clipped-left v-on="{ ...menu }" dense>
          <v-toolbar flat style="z-index: 10" dense>
            <v-toolbar-title><v-icon class="mr-4">{{ nameToIconMap[$route.path] }}</v-icon> {{ currentPageTitle }} <v-icon>{{ arrowIcon }}</v-icon></v-toolbar-title>
          </v-toolbar>
        </v-app-bar>
      </template>

      <v-card style="z-index: 999" flat>
        <v-list>
          <v-list-item v-if="canReadUsers" :to="{name: 'users'}" exact class="toolbar-users" @click="menu = !menu">
            <v-list-item-icon><v-icon>mdi-account-group</v-icon></v-list-item-icon>
            <v-list-item-title>{{ $t('users.menuTitle') }}</v-list-item-title>
            <v-spacer />
            <v-list-item-action>
              <v-btn icon @click.stop.prevent="setAsLandingPage('/buddies')"><v-icon>{{ landingPageIcon('users') }}</v-icon></v-btn>
            </v-list-item-action>
          </v-list-item>
          <v-list-item v-if="canReadQueues" :to="{name: 'queues'}" class="toolbar-queues" @click="menu = !menu">
            <v-list-item-icon><v-icon>mdi-human-queue</v-icon></v-list-item-icon>
            <v-list-item-title>{{ $t('queues.menuTitle') }}</v-list-item-title>
            <v-list-item-action>
              <v-btn icon @click.stop.prevent="setAsLandingPage('/queues')"><v-icon>{{ landingPageIcon('queues') }}</v-icon></v-btn>
            </v-list-item-action>
          </v-list-item>
          <v-list-item v-if="canReadConferences" :to="{name: 'conferences'}" class="toolbar-conferences" @click="menu = !menu">
            <v-list-item-icon><v-icon>mdi-microphone-message</v-icon></v-list-item-icon>
            <v-list-item-title>{{ $t('confr.menuTitle') }}</v-list-item-title>
            <v-list-item-action>
              <v-btn icon @click.stop.prevent="setAsLandingPage('/conferences')"><v-icon>{{ landingPageIcon('conferences') }}</v-icon></v-btn>
            </v-list-item-action>
          </v-list-item>
          <v-list-item v-if="canUseVideoConference" :to="{name: 'video-conferences'}" class="toolbar-video-conferences" @click="menu = !menu">
            <v-list-item-icon><v-icon>mdi-video</v-icon></v-list-item-icon>
            <v-list-item-title>{{ $t('videoconf.menuTitle') }}</v-list-item-title>
            <v-list-item-action>
              <v-btn icon @click.stop.prevent="setAsLandingPage('/video_conferences')"><v-icon>{{ landingPageIcon('video-conferences') }}</v-icon></v-btn>
            </v-list-item-action>
          </v-list-item>
          <v-list-item v-if="canReadParking" :to="{name: 'parking'}" class="toolbar-parking" @click="menu = !menu">
            <v-list-item-icon><v-icon>mdi-car-brake-parking</v-icon></v-list-item-icon>
            <v-list-item-title>{{ $t('parking.menuTitle') }}</v-list-item-title>
            <v-list-item-action>
              <v-btn icon @click.stop.prevent="setAsLandingPage('/parking')"><v-icon>{{ landingPageIcon('parking') }}</v-icon></v-btn>
            </v-list-item-action>
          </v-list-item>
          <v-list-item v-if="canReadVMails" :to="{name: 'voicemails'}" class="toolbar-voicemails" @click="menu = !menu">
            <v-list-item-icon><v-icon>mdi-voicemail</v-icon></v-list-item-icon>
            <v-list-item-title>{{ $t('vmail.menuTitle') }}</v-list-item-title>
            <v-list-item-action>
              <v-btn icon @click.stop.prevent="setAsLandingPage('/voicemails')"><v-icon>{{ landingPageIcon('voicemails') }}</v-icon></v-btn>
            </v-list-item-action>
          </v-list-item>
          <v-list-item v-if="canReadCdrs" :to="{name: 'cdrs'}" class="toolbar-cdrs" @click="menu = !menu">
            <v-list-item-icon><v-icon>mdi-history</v-icon></v-list-item-icon>
            <v-list-item-title>{{ $t('cdrs.menuTitle') }}</v-list-item-title>
            <v-list-item-action>
              <v-btn icon @click.stop.prevent="setAsLandingPage('/cdrs')"><v-icon>{{ landingPageIcon('cdrs') }}</v-icon></v-btn>
            </v-list-item-action>
          </v-list-item>
          <v-list-item v-if="canReadAnnounce" :to="{name: 'announcements'}" class="toolbar-announcements" @click="menu = !menu">
            <v-list-item-icon><v-icon>mdi-bullhorn</v-icon></v-list-item-icon>
            <v-list-item-title>{{ $t('announce.menuTitle') }}</v-list-item-title>
            <v-list-item-action>
              <v-btn icon @click.stop.prevent="setAsLandingPage('/announcements')"><v-icon>{{ landingPageIcon('announcements') }}</v-icon></v-btn>
            </v-list-item-action>
          </v-list-item>
        </v-list>
        <v-card-actions class="justify-end">
          <v-btn
            text
            @click="menu = false"
          >{{ $t('tb.embedded.btn.close') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-menu>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'toolbar-embedded',
  data () {
    return {
      menu: false,
      pageToNameMap: {
        '/': 'users',
        '/buddies': 'users',
        '/queues': 'queues',
        '/conferences': 'conferences',
        '/video_conferences': 'video-conferences',
        '/voicemails': 'voicemails',
        '/announcements': 'announcements',
        '/parking': 'parking',
        '/cdrs': 'cdrs'
      },
      urlToLocaleMap: {
        '/': 'users',
        '/buddies': 'users',
        '/queues': 'queues',
        '/conferences': 'confr',
        '/video_conferences': 'videoconf',
        '/voicemails': 'vmail',
        '/announcements': 'announce',
        '/parking': 'parking',
        '/cdrs': 'cdrs'
      },
      nameToIconMap: {
        '/': 'mdi-account-group',
        '/buddies': 'mdi-account-group',
        '/queues': 'mdi-human-queue',
        '/conferences': 'mdi-microphone-message',
        '/video_conferences': 'mdi-video',
        '/voicemails': 'mdi-voicemail',
        '/announcements': 'mdi-bullhorn',
        '/parking': 'mdi-car-brake-parking',
        '/cdrs': 'mdi-history'
      }
    }
  },
  computed: {
    ...mapGetters({
      currentUser: 'currentUser/currentUser',
      canReadConfig: 'permissions/confRead',
      canReadSoftphone: 'permissions/softphoneRead',
      canReadUsers: 'permissions/usersRead',
      canReadQueues: 'permissions/queuesRead',
      canReadVideoConf: 'permissions/videoConfRead',
      canReadConferences: 'permissions/conferencesRead',
      canReadParking: 'permissions/parkRead',
      canReadVMails: 'permissions/vmailsRead',
      canReadCdrs: 'permissions/cdrsRead',
      canManagePersonalContacts: 'permissions/contactsManagePersonal',
      canReadAnnounce: 'permissions/announceRead',
      showMissedCalls: 'settings/showMissedCalls',
      clearlyAnywhereLandingPage: 'settings/clearlyAnywhereLandingPage',
      isVideoConferenceEnabled: 'videoConferenceConfig/enabled',
      licenseAllowsVideoConf: 'licenses/videoConfEnabled'
    }),
    canUseVideoConference () {
      return this.isVideoConferenceEnabled && this.canReadVideoConf && this.licenseAllowsVideoConf
    },
    mainPath () {
      return `/${this.$route.path.split('/')[1]}`
    },
    currentPageTitle  () {
      const title = this.urlToLocaleMap[this.mainPath]
      if (title) {
        return this.$t(`${this.urlToLocaleMap[this.mainPath]}.menuTitle`)
      } else {
        return ''
      }
    },
    arrowIcon () {
      const title = this.urlToLocaleMap[this.mainPath]
      if (title) {
        return this.menu ? 'mdi-menu-up' : 'mdi-menu-down'
      } else {
        return ''
      }
    }
  },
  methods: {
    ...mapActions({
      setClearlyAnywherelandingPage: 'settings/setClearlyAnywherelandingPage'
    }),
    landingPageIcon (btnName) {
      return this.pageToNameMap[this.clearlyAnywhereLandingPage] === btnName ? 'mdi-heart' : 'mdi-heart-outline'
    },
    setAsLandingPage (btnPath) {
      this.menu = true
      this.setClearlyAnywherelandingPage(btnPath)
    }
  }
}
</script>

<style>
</style>
